import type { CandidateDto } from '../candidate.dto';

export type Insights = {
  candidate: {
    new: boolean;
    updated: boolean;
  };
  education: {
    added: boolean;
    dateChanged: boolean;
    obtainedDegreeChanged: boolean;
  };
  job: {
    added: boolean;
    roleChanged: boolean;
    descriptionChanged: boolean;
    dateChanged: boolean;
  };
  skill: {
    added: boolean;
  };
  preferred: {
    employmentTypeChanged: boolean;
    workHoursChanged: boolean;
  };
  work: {
    availabilityChanged: boolean;
  };
  location: {
    changed: boolean;
  };
  phone: {
    added: boolean;
    changed: boolean;
  };
  email: {
    added: boolean;
    changed: boolean;
  };
};

export type Insight = {
  createdAt: string;
  type: string;
};

class InsightChecker {
  private insights: Insight[];
  constructor(insights: Insight[]) {
    this.insights = insights;
  }

  check(type: string, config?: { checkDiff: boolean }): boolean {
    const findedInsight = this.insights.find((insight: Insight) => {
      const insightCreatedAtPlusSevenDays = new Date(insight.createdAt);
      insightCreatedAtPlusSevenDays.setDate(insightCreatedAtPlusSevenDays.getDate() + 7);

      const today = new Date();

      return (
        (config?.checkDiff ? insight.type !== type : insight.type === type) && insightCreatedAtPlusSevenDays > today
      );
    });

    return !!findedInsight;
  }
}

export const toInsights = (dto: CandidateDto): Insights => {
  const insights = dto._source.insights ?? [];

  // TODO: Ask leo about this logic
  // let createdAt = dto._source.last_insight_date;

  // const lastInsightIndex = insights.length - 1;
  // const lastInsight = insights[lastInsightIndex];

  // if (lastInsight && !lastInsight?.createdAt && dto._source.last_insight_date) {
  //   createdAt = new Date(dto._source.last_insight_date);
  // }

  const insightChecker = new InsightChecker(insights);

  return {
    candidate: {
      new: insightChecker.check('candidate.added'),
      updated: insights.length > 0 && insightChecker.check('candidate.added', { checkDiff: true }),
    },
    education: {
      added: insightChecker.check('educations.added'),
      dateChanged:
        insightChecker.check('educations_dates_start.changed') || insightChecker.check('educations_dates_end.changed'),
      obtainedDegreeChanged: insightChecker.check('educations_obtainedDegree.changed'),
    },
    job: {
      added: insightChecker.check('jobs.added'),
      roleChanged: insightChecker.check('jobs_role.changed'),
      descriptionChanged: insightChecker.check('jobs_description.changed'),
      dateChanged: insightChecker.check('jobs_dates_start.changed') || insightChecker.check('jobs_dates_end.changed'),
    },
    skill: {
      added: insightChecker.check('skills.added'),
    },
    preferred: {
      employmentTypeChanged: insightChecker.check('preferences_employmentType.changed'),
      workHoursChanged: insightChecker.check('preferences_workHours.changed'),
    },
    work: {
      availabilityChanged: insightChecker.check('preferences_availability.changed'),
    },
    location: {
      changed: insightChecker.check('location_raw.changed'),
    },
    phone: {
      added: insightChecker.check('contact_info_phone.added'),
      changed: insightChecker.check('contact_info_phone.changed'),
    },
    email: {
      added: insightChecker.check('contact_info_email.added'),
      changed: insightChecker.check('contact_info_email.changed'),
    },
  };
};
